import { createResource, type RouterContext, type RouteResource } from 'react-resource-router';

import { UrlHelper } from '../../../common/utils/url-helper';
import { default as ConfiguredSyncsAPI } from '../endpoints';

import type { ConfiguredSyncsResource } from './types';

export const configuredSyncsResource: RouteResource<ConfiguredSyncsResource> =
	createResource<ConfiguredSyncsResource>({
		type: 'configuredSyncsResource',
		getKey: ({ query, match }: RouterContext): string => {
			const teamId = match.params.teamId ?? query['teamId'];
			const keyword = query['keyword'];
			const type = query['type'];
			const page = query['page'] || '1';
			const status = query['status'];

			return UrlHelper('configuredSyncsResource', {
				page,
				keyword,
				type,
				status,
				teamId,
			});
		},
		getData: (routerContext) =>
			ConfiguredSyncsAPI.getSyncs(routerContext.query, routerContext.match.params.teamId),
		maxAge: 5 * 60 * 1000, // 5 mins
		isBrowserOnly: true,
	});
